import React from 'react'

/**
 * Simple SVGInline component replacement for react-svg-inline
 * Compatible with React 18
 */
const SVGInline = ({ svg, className, width, height, style, ...props }) => {
  const inlineStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...(width && { width }),
    ...(height && { height }),
    ...style,
  }

  const processedSVG = svg
    ? svg.replace(/<svg/, '<svg style="width: 100%; height: 100%;"')
    : ''

  return (
    <div
      className={className}
      style={inlineStyle}
      dangerouslySetInnerHTML={{ __html: processedSVG }}
      {...props}
    />
  )
}

export default SVGInline
